import { survey, questions, questionAnswers } from './stores';
import { getAnswer, getAllQuestions, getSurvey } from './api.js';
import { Question } from './models/Question';
import { QuestionAnswer } from './models/QuestionAnswer';

export function stripHtml(text, preserveNewline = false) {
    let s = text;

    if (preserveNewline) {
        s = s.replace(/(<br>|<br *\/>|<\/p>|<\/tr>|<\/li>)/gmi, '\n');
    }

    s = s.replace(/(<[^>]*>?|&nbsp;)/gm, ' ');
    s = s.replace(/ {2,}/gm, ' ');
    s = s.replace(/\n /gm, '\n');
    s = s.trim();

    return s;
}

/**
 * Check if the document exists in an iframe.
 * @returns true if exists in an iframe, otherwise false
 */
export function isInIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

/**
 * Load the survey into store objects.
 * @returns {Boolean} true, if loading was ok
 */
export async function loadSurvey() {
    let surveyFromApi = {};
    let errorFromApi = false;

    try {
        const result = await getSurvey();

        surveyFromApi = result;

        survey.set(surveyFromApi);
    } catch {
        errorFromApi = true;
    }

    if (surveyFromApi.isCreated) {
        try {
            const allQuestions = await getAllQuestions();

            questions.set(allQuestions.questions.map(q => new Question(q)));
        } catch {
            errorFromApi = true;
        }

        if (surveyFromApi.answerId > 0) {
            try {
                const answers = await getAnswer(surveyFromApi.answerId);

                if (answers.questionAnswers) {
                    questionAnswers.set(answers.questionAnswers.map(a => new QuestionAnswer(a)));
                }
            } catch {
                errorFromApi = true;
            }
        }
    }

    return errorFromApi;
}
